import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPatientJourneyById,
} from "../../../reducer/slices/conversation/patientJourney";
import { useNavigate } from "react-router";

const statusClasses = {
  "All": "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  "Qualified": "bg-[#15B392]",
  "Booked": "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]"
};

const PatientJourneyIn = ({ trialInfo, trialList }) => {

  const dispatch = useDispatch();
   const navigate = useNavigate();
  const ACTIVE_COLOR = "#245CEA";
  const INACTIVE_COLOR = "#E4E4E4";

  const { trials, loading, error } = useSelector(
    (state) => state.patientJourney
  );

  const patientId = trialInfo?.patientID
  const currentPatientTrialJuncID = trialInfo?.patientTrialJuncID;
  console.log('trialInfo => ', trials)

  useEffect(() => {
    if (patientId) {
      dispatch(fetchPatientJourneyById(patientId));
    }
  }, [patientId, dispatch]);



  //if (loading) return <p>Loading...</p>;
  if (error) return <p>Error occurred</p>;

  return (
    <>
      {/* <h2 className='mb-2'>{trialInfo?.trialName}</h2> */}

      {/* {trialInfo?.status && (<span className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble ${statusClasses[trialInfo?.status] || "bg-gray-200"}`}>{trialInfo?.status}</span>)} */}

      {trials.map((trial, index) => {
        const isActive = index === 0; // first item active
        const isLast = index === trials.length - 1;
        const showLine = trials.length > 1 && !isLast;

        return (
          <div key={index} className="flex gap-4 relative">

            {/* Timeline Column */}
            <div className="flex flex-col items-center">
              {/* Bullet */}

              {currentPatientTrialJuncID !== trial?.patientTrialJuncID ? (<div
                className="w-3 h-3 rounded-full mt-1.5 z-[9]"
                style={{
                  backgroundColor: isActive ? ACTIVE_COLOR : INACTIVE_COLOR,
                }}
              />) : (<div
                className="w-3 h-3 rounded-full mt-1.5  z-[9] ring-2 ring-blue-600 ring-offset-2 ring-offset-white"
                style={{
                  backgroundColor: isActive ? ACTIVE_COLOR : INACTIVE_COLOR,
                }}
              ></div>)}



              {/* Line */}
              {showLine && (
                <div
                  className="flex-1 w-[2px]"
                  style={{
                    backgroundColor: INACTIVE_COLOR,
                  }}
                />
              )}
            </div>

            {/* Content */}
            <div className="pb-6">
              <h2 className="mb-1 font-medium cursor-pointer  hover:font-semibold hover:underline" onClick={()=>{
                 navigate(`/conversation-patients/${trial.patientTrialJuncID}`, { replace: true });
              }}>
                {trial?.trialName}
              </h2>

              <span
                className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble ${statusClasses[trial?.statusName] || "bg-gray-200"}`}
              >
                {trial?.statusName}
              </span>
            </div>
          </div >
        );
      })}

    </>
  )
}

export default PatientJourneyIn